module.exports = __webpack_public_path__ + "img/camera.fe7604d3.svg";